<template>
  <div class="chain-selector">
    <span @click="openModal">
      <slot />
    </span>
    <b-modal
      ref="chainsModal"
      :title="getLabel('CHAIN_SELECTOR_SELECT_CHAINS')"
      size="lg"
    >
      <b-form-group>
        <b-button variant="light" @click="selectAll()">
          <span v-label-key="'SELECT_ALL'">Select all</span>
        </b-button>
        <b-button variant="light" @click="selectNone()">
          <span v-label-key="'SELECT_NONE'">Select none</span>
        </b-button>

        <b-form-checkbox-group v-model="selectedChains" stacked>
          <b-form-checkbox
            v-for="chain in chains"
            :key="chain.id"
            :value="chain.id"
          >
            {{ chain.name }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <div slot="modal-footer">
        <b-button variant="primary" @click="save()">
          <span v-label-key="'SELECT'">select</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    chainIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedChains: [],
    };
  },
  computed: {
    ...mapState('global', {
      chains: 'chains',
    }),
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  methods: {
    openModal() {
      this.selectedChains = this.chainIds;
      this.$refs.chainsModal.show();
    },
    save() {
      const chainIds = this.selectedChains;
      this.$emit('select', chainIds);
      this.$refs.chainsModal.hide();
    },
    selectAll() {
      this.selectedChains = this.chains.map(chain => chain.id);
    },
    selectNone() {
      this.selectedChains = [];
    },
  },
};
</script>
